module.exports = __webpack_public_path__ + "static/media/atom_orbit.230135b7.svg";